
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M60.2 119.5c-8.3-12-13.8-20.1-16.5-24.2-3.8-6-6.4-11-7.8-15.1-1.4-4.1-2-8.8-2-14.1 0-8.7 2.2-16.7 6.5-24 4.3-7.3 10.2-13.2 17.5-17.5 7.3-4.3 15.3-6.5 24-6.5s16.7 2.2 24 6.5c7.3 4.3 13.2 10.2 17.5 17.5 4.3 7.3 6.5 15.3 6.5 24 0 5.3-.7 10-2 14.1s-3.9 9.1-7.8 15.1c-2.7 4.2-8.2 12.2-16.5 24.2l-16.8 24c-1.2 1.7-2.8 2.5-5 2.5s-3.8-.8-5-2.5c-4.1-6.3-9.7-14.3-16.6-24zm35.9-39.4c3.9-3.9 5.9-8.6 5.9-14.1s-2-10.2-5.9-14.1C92.2 48 87.5 46 82 46s-10.2 2-14.1 5.9C64 55.8 62 60.5 62 66s2 10.2 5.9 14.1C71.8 84 76.5 86 82 86s10.2-2 14.1-5.9z"}})])
          )
        }
      }
    